export default class SortTiles {
  constructor(button, listElement) {
    this.button = button;
    this.list = listElement;
    this.items = Array.from(this.list.querySelectorAll('.list-events-item'));

    this._setActiveButton();
  }

  sortByDate() {
    this.items.sort((a, b) => {
      const dateA = a.querySelector('.tile').dataset.date;
      const dateB = b.querySelector('.tile').dataset.date;
      return parseInt(dateA) - parseInt(dateB);
    });

    this._render();
  }

  sortByDistance() {
    if (!navigator.geolocation) {
      console.warn('Geolocation is not supported.');
      return;
    }

    navigator.geolocation.getCurrentPosition(position => {
      const userLat = position.coords.latitude;
      const userLng = position.coords.longitude;

      this.items.sort((a, b) => {
        const tileA = a.querySelector('.tile');
        const tileB = b.querySelector('.tile');

        const distA = this._getDistance(userLat, userLng, parseFloat(tileA.dataset.lat), parseFloat(tileA.dataset.lng));
        const distB = this._getDistance(userLat, userLng, parseFloat(tileB.dataset.lat), parseFloat(tileB.dataset.lng));

        return distA - distB;
      });

      this._render();
    });
  }

  _setActiveButton() {
    const siblings = this.button.parentElement.querySelectorAll('button');
    siblings.forEach(btn => btn.classList.remove('active'));
    this.button.classList.add('active');
  }

  _getDistance(lat1, lng1, lat2, lng2) {
    const R = 6371;
    const dLat = this._toRad(lat2 - lat1);
    const dLng = this._toRad(lng2 - lng1);
    const a = Math.sin(dLat / 2) ** 2 +
              Math.cos(this._toRad(lat1)) * Math.cos(this._toRad(lat2)) *
              Math.sin(dLng / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  _toRad(deg) {
    return deg * Math.PI / 180;
  }

  _render() {
    this.items.forEach(item => this.list.appendChild(item));
  }
}


export { SortTiles };